import { useEffect, useState } from 'react';
import { useDebounce } from './useDebounce';

export const useMobileSizeDetect = (pixel: 1020) => {
  const isClient = typeof window !== 'undefined';
  useEffect(() => {
    const handleResize = () => {
      widthResize(getSize());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  if (!isClient) {
    return false;
  }
  const getSize = () => isClient && window.innerWidth;
  const [windowSize, setWindowSize] = useState<number>(getSize);
  const widthResize = useDebounce((px: number) => {
    setWindowSize(px);
  }, 100);

  return windowSize < pixel + 1;
};
